import { IUsersHook } from '@models';
import { UserService } from '@services';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

export const useUsers = (technicianOnly?: boolean): IUsersHook => {
  const { userStore } = useStore();
  const {
    loading,
    users,
    totalCount,
    currentPage,
    maxResultCount,
    skipCount,
    setSkipCount,
    setCurrentPage,
    handlePageChange,
  } = userStore;
  const [fullname, setFullname] = useState<string>();
  const [email, setEmail] = useState<string>();

  useEffect(() => {
    return () => userStore.clearUsers();
  }, [userStore]);

  useEffect(() => {
    userStore.getAll({
      fullname,
      email,
      maxResultCount,
      skipCount,
      technicianOnly,
    });
  }, [userStore, fullname, email, maxResultCount, skipCount, technicianOnly]);

  const handleFullnameSearch = debounce((text: string) => {
    setFullname(text);
    setSkipCount(0);
    setCurrentPage(1);
  }, 500);

  const handleEmailSearch = debounce((text: string) => {
    setEmail(text);
    setSkipCount(0);
    setCurrentPage(1);
  }, 500);

  const fetchAllForExport = useCallback(async () => {
    const result = await UserService.getAll({
      fullname,
      email,
      technicianOnly,
      maxResultCount: totalCount || 10000,
      skipCount: 0,
    });
    return result.items;
  }, [fullname, email, technicianOnly, totalCount]);

  return {
    loading,
    dataSource: Array.from(users.values()),
    totalCount,
    currentPage,
    maxResultCount,
    handleEmailSearch,
    handleFullnameSearch,
    handlePageChange,
    fetchAllForExport,
  };
};
